import { Requester } from './Requester';
import { ILoanGroupRecord } from '../types';

export const PatchOrganizationLoanGroup = async ({
    loanGroupId,
    loanGroup
}: {
    loanGroupId?: string;
    loanGroup: Record<string, any>;
}): Promise<ILoanGroupRecord | null> => {
    if (!loanGroupId) return null;
    try {
        const response = await Requester<ILoanGroupRecord | null>({
            path: `loanGroups/${loanGroupId}`,
            method: 'PATCH',
            payload: loanGroup
        });

        return response && Object.hasOwn(response, '_id') ? (response as ILoanGroupRecord) : null;
    } catch (e) {
        console.error('Patch organization loan group request failed');
        return Promise.reject(e);
    }
};
